module.exports = __webpack_public_path__ + "static/media/EVEREVE-TrensendStackedLogoNavy.3a75269c.png";